import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import Button from "react-bootstrap-button-loader";
import {
  checkProposalReviewCriteria,
  addCriteria,
  fetchProposalStep,
  fetchSingleProposal,
  editProposal,
  updateCriteria,
  fetchProposal,
  deletebulkCriteria,
} from "ProposalAction";
import LocaleStrings from "Languages";
import { LABEL_POSITION_TOP } from "BaseComponent";

class EditCriteria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      stepArr: [{ key: 0, catname: "", range: "" }],
      key: 0,
      dateError: [],
      removeablCriteriaid: [],
    };
  }

  componentDidMount() {
    if (
      this.props.updateProposal &&
      this.props.updateProposal.review_criteria_by_proposalidfk &&
      this.props.updateProposal.review_criteria_by_proposalidfk.length > 0
    ) {
      let stepArr = [];
      _.map(
        this.props.updateProposal.review_criteria_by_proposalidfk,
        (crt, index) => {
          let obj = {
            criteriaid: crt.criteriaid,
            eventid: crt.eventid,
            catname: crt.categoryname,
            key: index,
            range: crt.range,
          };
          stepArr.push(obj);
        }
      );
      this.setState({ stepArr: stepArr });
    }
  }

  renderFieldRadio(field) {
    return (
      <div>
        <label
          className="custom-container-radio liveqa-label"
          style={{ marginBottom: 5 }}
        >
          {field.label}
          <input {...field.input} type={field.type} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }

  renderFieldText(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12 m-0 mb-5";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  addMoreCat = () => {
    let stepArr = this.state.stepArr;

    let key = this.state.key + 1;

    let obj = { key: key, catname: "", range: "" };
    stepArr.push(obj);

    this.setState({ stepArr: stepArr, key: key });
  };

  removeCat = () => {
    let stepArr = this.state.stepArr;
    let removedArr = [];
    let { removeablCriteriaid } = this.state;
    //let newOptions = _.filter(stepArr, obj => {return obj.key != item.key});
    //   let newOptions = [];
    //   _.map(stepArr, (opt, index) => {
    //     if (index < stepArr.length - 1) {
    //       newOptions.push(opt);
    //     }
    //   });
    //  let removedobjArr = stepArr[stepArr.length - 1];
    //  console.log('removedobjArr',removedobjArr)
    //   this.setState({ stepArr: newOptions });
    //   this.props.change(this.props.pristine, false);

    let removedObj = stepArr[stepArr.length - 1];
    removeablCriteriaid.push(removedObj);
    this.setState({ removeablCriteriaid });
    stepArr.pop();
    this.setState({ stepArr });
    this.props.change(this.props.pristine, false);
  };

  onSubmitForm = (values) => {
    //console.log('values',values);

    if (values.proposalid) {
      let stepArr = this.state.stepArr;
      let catLength = stepArr.length;

      let c = 0;

      var dateError = [];
      for (var i = 0; i < catLength; i++) {
        var errorMessage = {};
        if (!values["categoryname" + i]) {
          errorMessage.categoryname =
            LocaleStrings.tickets_ticket_form_validation_required;
          c++;
        } else {
          errorMessage.categoryname = "";
        }
        if (!values["range" + i]) {
          errorMessage.range =
            LocaleStrings.tickets_ticket_form_validation_required;
          c++;
        } else {
          errorMessage.range = "";
        }
        dateError.push(errorMessage);
        // let obj = {categoryname:values['categoryname'+i] ,range:values['range'+i],proposalidfk:proposalForm.proposalid}
        // criteriaArr.push(obj);
      }

      if (c > 0) {
        this.setState({ dateError: dateError });

        setTimeout(() => {
          this.setState({ dateError: [] });
        }, 2000);
      } else {
        let criteriaArrInsert = [];
        let criteriaArrUpdate = [];
        for (var i = 0; i < catLength; i++) {
          if (values["criteriaid" + i]) {
            let obj = {
              criteriaid: values["criteriaid" + i],
              categoryname: values["categoryname" + i],
              range: values["range" + i],
              proposalidfk: values.proposalid,
              eventid: this.props.session.eventid,
            };
            criteriaArrUpdate.push(obj);
          } else {
            let obj = {
              categoryname: values["categoryname" + i],
              range: values["range" + i],
              proposalidfk: values.proposalid,
              eventid: this.props.session.eventid,
            };
            criteriaArrInsert.push(obj);
          }
        }

        let errorShow = false;

        if (criteriaArrInsert.length > 0) {
          this.setState({ loading: true });
          this.props.addCriteria(
            this.props.session,
            criteriaArrInsert,
            (response) => {
              if (response.success === 0) {
                errorShow = true;
                // this.setState({loading:false});
                // this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                errorShow = false;
              }
            }
          );
        }

        if (criteriaArrUpdate.length > 0) {
          this.setState({ loading: true });

          this.props.updateCriteria(
            this.props.session,
            criteriaArrUpdate,
            (response) => {
              if (response.success === 0) {
                errorShow = true;
              } else {
                if (this.state.removeablCriteriaid.length > 0) {
                  this.props.deletebulkCriteria(
                    this.props.session,
                    this.state.removeablCriteriaid,
                    (response) => {
                      errorShow = false;
                    }
                  );
                }
              }
            }
          );
        }

        if (errorShow) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          if (this.props.editMode) {
            this.props.fetchProposal(this.props.session, (callback) => {});
            this.props.fetchSingleProposal(
              this.props.session,
              values.proposalid,
              (response) => {
                let proposalList = response.data;
                this.props.editProposal(proposalList[0]);
              }
            );
          } else {
            this.props.checkProposalReviewCriteria(this.props.session);
          }

          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.proposal_review_criteria_add_succesfully
          );
          this.props.fetchProposalStep("step_5");
        }
      }
    }
  };

  renderHiddenFieldText(field) {
    var labelposition = field.labelposition;
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group row ${formdiv} ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    return (
      <div className={divClassName} style={{ display: "none" }}>
        {field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  render() {
    var { handleSubmit, pristine, reset, submitting, invalid, initialValues } =
      this.props;
    var { stepArr } = this.state;

    return (
      <div className="row" style={{ marginLeft: "0px" }}>
        <div
          className="col-md-8 mb-15"
          style={{ marginLeft: "-15px", fontWeight: "bold" }}
        >
          {/* *You must need to publish once after updating the data */}
        </div>
        <div className="col-md-12 px-15">
          <label className="setting-company-section-heading">
            {LocaleStrings.proposal_wizard_review_criteria_heading}
          </label>
          <p>{LocaleStrings.proposal_wizard_review_criteria_subheading}</p>
        </div>
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          {_.map(stepArr, (opt, index) => {
            return (
              <div
                className="col-md-9 reviewer-criteria-box"
                style={{ marginBottom: "20px", marginLeft: 0 }}
              >
                <Field
                  name={"criteriaid" + index}
                  type="text"
                  component={this.renderHiddenFieldText}
                  bsClass="row"
                />
                <Field
                  name={"categoryname" + index}
                  label={LocaleStrings.proposal_wizard_review_category_name}
                  placeholder={
                    LocaleStrings.proposal_wizard_review_category_name
                  }
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                />
                {this.state.dateError &&
                this.state.dateError[index] &&
                this.state.dateError[index].categoryname &&
                this.state.dateError[index].categoryname !== "" ? (
                  <span style={{ color: "#d43f3a" }}>
                    {this.state.dateError[index].categoryname}
                  </span>
                ) : (
                  ""
                )}

                <div className="form-group px-15">
                  <label
                    className="control-label-top col-sm-12 mb-5"
                    style={{ padding: 0 }}
                  >
                    {LocaleStrings.proposal_wizard_review_category_range}
                    <span className="label-mandatory">*</span>
                  </label>
                  <div
                    className="col-md-12"
                    style={{ padding: 0, display: "flex" }}
                  >
                    <Field
                      name={"range" + index}
                      label="1-5"
                      component={this.renderFieldRadio}
                      type="radio"
                      value="1-5"
                      onChange={this.changeDistribution}
                    />{" "}
                    <Field
                      name={"range" + index}
                      label="1-10"
                      component={this.renderFieldRadio}
                      type="radio"
                      value="1-10"
                      onChange={this.changeDistribution}
                    />
                  </div>
                  {this.state.dateError &&
                  this.state.dateError[index] &&
                  this.state.dateError[index].range &&
                  this.state.dateError[index].range !== "" ? (
                    <span style={{ color: "#d43f3a" }}>
                      {this.state.dateError[index].range}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            );
          })}

          {/* <div
            className="col-md-12 px-15"
            style={{ marginTop: "10px", marginBottom: "20px" }}
          >
            <a className="pointer" onClick={this.addMoreCat}>
              <i className="fa fa-plus"></i> Add more
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {stepArr.length > 1 ? (
              <a className="pointer" onClick={() => this.removeCat()}>
                <i className="fa fa-minus"></i> Remove
              </a>
            ) : (
              ""
            )}
          </div> */}
          <div className="col-md-12 mt-10 mb-10">
            <button
              className="reviewer-criteria-add-btn flex"
              type="button"
              onClick={this.addMoreCat}
            >
              <i className="fa fa-plus"></i>
              <span style={{ paddingLeft: "5px" }}>Add more</span>
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {stepArr.length > 1 ? (
              <button
                className="reviewer-criteria-add-btn flex"
                type="button"
                onClick={() => this.removeCat()}
              >
                <i className="fa fa-minus"></i>
                <span style={{ paddingLeft: "5px" }}>Remove</span>
              </button>
            ) : (
              ""
            )}
          </div>
          {/* <div className="form-group px-15"> 
                        <label className="control-label-top col-sm-12 mb-5" style={{padding:0}}>{LocaleStrings.proposal_wizard_review_criteria_allow_note}<span className="label-mandatory">*</span></label>
                        <div className="col-md-12" style={{padding:0, display: 'flex'}}>
                            <Field name="addnote" label="Yes" component={this.renderFieldRadio} type="radio" value="yes" onChange={this.changeDistribution} /> 
                            {' '}
                            <Field  name="addnote" label="No" component={this.renderFieldRadio} type="radio" value="no" onChange={this.changeDistribution} /> 
                        
                        </div>
                    </div> */}
          <div className="col-md-12 px-15" style={{ marginTop: "30px",marginLeft:'-25px' }}>
            <Button
              className="btn btn-custom-blue ml-10"
              bsStyle=""
              loading={this.state.loading}
              disabled={pristine || invalid || submitting}
              type="submit"
            >
              {LocaleStrings.proposal_wizard_review_category_save_button}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var initVals = {};

  if (state.updateProposal && state.updateProposal.proposalid) {
    initVals = state.updateProposal ? state.updateProposal : {};

    if (
      state.updateProposal &&
      state.updateProposal.review_criteria_by_proposalidfk &&
      state.updateProposal.review_criteria_by_proposalidfk.length > 0
    ) {
      _.map(
        state.updateProposal.review_criteria_by_proposalidfk,
        (crt, index) => {
          initVals["categoryname" + index] = crt.categoryname;
          initVals["range" + index] = crt.range;
          initVals["criteriaid" + index] = crt.criteriaid;
        }
      );
    }
  }

  //console.log('initVals',initVals);

  return {
    session: state.session,
    initialValues: initVals,
    updateProposal: state.updateProposal,
    editMode: !_.isEmpty(state.updateProposal),
  };
}

function validate(values) {
  var errors = {};
  var addnote = values["addnote"];
  if (!addnote) {
    errors["formid"] = LocaleStrings.tickets_ticket_form_validation_required;
  }

  return errors;
}

export default connect(mapStateToProps, {
  checkProposalReviewCriteria,
  addCriteria,
  fetchProposalStep,
  showError,
  showSuccess,
  fetchSingleProposal,
  editProposal,
  updateCriteria,
  fetchProposal,
  deletebulkCriteria,
})(
  reduxForm({
    validate,
    form: "ReviewerCriteriaForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EditCriteria)
);
